exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".category-info{width:8rem;margin:.5rem;display:inline-block;cursor:pointer;text-overflow:ellipsis;overflow:hidden}.category-info .block{height:2rem;width:2rem;margin:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-339375d1!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CategoryInfoBlock.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-339375d1!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CategoryInfoBlock.vue
// module chunks = 0